import pythonApiClient from './pythonBaseApi';

/**
 * GET /consultas/hoteleria/camas-disponibles
 * Header: X-Proyecto-ID
 */
const consultaCamasDisponiblesApi = {
  consultar: async (proyectoId) => {
    const response = await pythonApiClient.get('/consultas/hoteleria/camas-disponibles', {
      headers: { 'X-Proyecto-ID': proyectoId },
    });
    return response.data;
  },
};

export default consultaCamasDisponiblesApi;
